<svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="7.4082" y="4" width="9.18367" height="16" fill="#3B7DD8"/>
<path d="M16.592 20V24H3.42871L3.42872 4H7.40831V20H16.592Z" fill="#64A1F4"/>
<path d="M20.5715 20H16.5919V4L7.4082 4L7.4082 4.79962e-07L20.5715 0L20.5715 20Z" fill="#FFC53D"/>
</svg>
